import React from 'react';
import Icon from '@common/components/icon';
import { FullConversation } from '@modules/chat/types/objects';
import Badge from '@common/components/badge';
import './styles.scss';

interface ConversationStatusProps {
  conversation: FullConversation;
}

const ConversationStatus = ({ conversation }: ConversationStatusProps) => {
  return (
    <div className="ConversationStatus tw-flex tw-items-center tw-gap-2">
      {conversation.is_pinned && <Icon color="grey-50" type="pin" size={16} />}
      {conversation.last_message &&
        (!conversation.last_message?.seen || conversation.last_message?.is_default_seen) && (
          <Badge text="" className="Badge" />
        )}
    </div>
  );
};

export default ConversationStatus;
